import type { AdminMember } from '@grc/shared';
import { t, type Code } from '../../i18n';

/**
 * A member's tags, in the list and on their page (D23): the admin's own row, an admin, a disabled
 * account, and a one-time password the member hasn't replaced yet.
 */
export function MemberTags({ member, own }: { member: AdminMember; own: boolean }) {
  const tags: [label: Code, kind: string][] = [];
  if (own) tags.push(['members.tagYou', 'tag-you']);
  if (member.role === 'admin') tags.push(['members.tagAdmin', 'tag-admin']);
  if (member.status === 'disabled') tags.push(['members.tagDisabled', 'tag-disabled']);
  if (member.mustChangePassword) tags.push(['members.tagOneTime', 'tag-onetime']);
  if (tags.length === 0) return null;
  return (
    <span className="tags">
      {tags.map(([label, kind]) => (
        <span key={label} className={`tag ${kind}`}>
          {t(label)}
        </span>
      ))}
    </span>
  );
}
